import { Paper } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { compose } from "recompose";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../components/withRouter";
import endpoint from "../../config/endpoints";
import { noInternetMsg, saveFailedMsg, savemsg, saveWarningMsg, serverMsg, updateData, updateFailed, updateMsg } from "../../config/messageconstant";
import { mandatoryCheck } from "../../config/ValidationCheck";
import { holidayStructureJson } from "../../DynamicFormsJson/Transaction/holidayStructure";
import { getHoliday, getHolidayYear, setHoliday } from "../../Slice/year.slice";
import { apiGet, apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";
import HolidayStructureDetailsTable from "./HolidayStructureDetailsTable";

class HolidayStructureForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                holidayYearMasterDetail: this.props.holidayList?.holidayYear,
            },
            holidayType: 0,
            formErrors: {},
            fieldData: {},
        }
    }

    async componentDidMount() {
        const { getHoliday, getHolidayYear, showLoador, showNotification } = this.props;
        if (navigator.onLine) {

            showLoador({ loador: true });
            await getHoliday().then(({ response, success }) => {
                if (!success) {
                    showNotification({
                        msg: serverMsg,
                        severity: "error",
                    });
                }
            });

            await getHolidayYear().then(({ response, success }) => {
                if (!success) {
                    showNotification({
                        msg: serverMsg,
                        severity: "error",
                    });
                }
            });
            showLoador({ loador: false });

            if (this.props.params.id) {
                this.getDataById(this.props.params.id)
            }

        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }


    componentWillReceiveProps(nextProps) {
        if (
            this.props.holidayList.holidayYear !==
            nextProps.holidayList.holidayYear
        ) {
            this.setState({
                dynamicMasterData: {
                    ...this.state.dynamicMasterData,
                    holidayYearMasterDetail: nextProps.holidayList.holidayYear,
                },
            });
        }
    }
    getDataById = async (id) => {
        const { showLoador, holidayList, setHoliday } = this.props;
        if (navigator.onLine) {
            showLoador({ loador: true });
            const response = await apiGet({
                url: endpoint.holidayStructureHeader + "/" + id,
            }).then(({ data, success }) => {
                if (success) {
                    if (!data.error) {
                        let rowData = data.data;

                        const updatedHolidayList = holidayList?.holiday.map((dataObj) => {
                            const matched = rowData.holidayStructureDetails.find(
                                (detailObj) => detailObj.holiday.id == dataObj.id
                            );
                            return {
                                ...dataObj,
                                holidayType: matched?.holidayType || 0,
                                holidayDetailsId: matched?.id,
                            };
                        });

                        setHoliday({ row: updatedHolidayList });

                        this.setState({
                            fieldData: {
                                name: rowData?.name,
                                optionalLimit: rowData?.optionalLimit,
                                holidayYearMaster: rowData?.holidayYearMaster.id,
                            }
                        });
                        return { data: rowData, success };
                    }
                    return { data: {}, success: false };
                }

                return { data: {}, success: false };
            });
            showLoador({ loador: false });

            return response;
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };


    onChangeRadioGroup = (e, id) => {
        const { holidayList, setHoliday } = this.props;
        const updatedList = holidayList?.holiday.map((dataObj) => {
            if (dataObj.id == id) {
                return {
                    ...dataObj,
                    holidayType: Number(e.target.value),
                };
            }
            return dataObj;
        });
        setHoliday({ row: updatedList });
    };

    checkValidationOnSubmit = () => {
        const { fieldData } = this.state;
        const mandatoryCheckErrors = mandatoryCheck({
            fieldData,
            fieldMeta: holidayStructureJson.fieldMeta,
        });
        this.setState({
            formErrors: mandatoryCheckErrors.formErrors,
        });

        return mandatoryCheckErrors.formValid;
    };

    submithandler = () => {
        const { holidayList } = this.props;
        const { fieldData } = this.state;

        const matchedHolidayYearObj = holidayList?.holidayYear.find((row) => row.id == fieldData?.holidayYearMaster)

        let holidayStructureDetailsList = holidayList?.holiday.map((dataObj) => {
            return {
                id: this.props.params.id ? dataObj?.holidayDetailsId : undefined,
                holiday: { id: dataObj.id },
                day: dataObj.day,
                month: dataObj.month,
                holidayType: dataObj.holidayType,
            }
        });

        let dataToSave = {
            id: this.props.params.id,
            name: fieldData?.name,
            optionalLimit: fieldData?.optionalLimit,
            fromDate: matchedHolidayYearObj?.fromDate,
            toDate: matchedHolidayYearObj?.toDate,
            holidayYearMaster: { id: matchedHolidayYearObj?.id },
            holidayStructureDetails: holidayStructureDetailsList,
        }

        if (this.checkValidationOnSubmit()) {
            this.onSave(dataToSave);
        }
    }

    onSave = (dataToSave) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {

            swal({
                title: "Are you sure?",
                text: this.props.params.id ? updateData : saveWarningMsg,
                icon: "warning",
                buttons: true,
                dangerMode: true,
            }).then(async (willDelete) => {
                if (willDelete) {
                    showLoador({ loador: true });
                    await apiPost({
                        url: endpoint.holidayStructureHeader,
                        postBody: dataToSave,
                    }).then(({ data, success }) => {
                        if (success) {
                            this.props.navigate(-1);
                            showNotification({ msg: this.props.params.id ? updateMsg : savemsg });
                        } else {
                            showNotification({ msg: this.props.params.id ? updateFailed : saveFailedMsg, severity: "error" });
                        }
                    });
                    showLoador({ loador: false });
                }
            });
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };


    onDataChange = (fieldName, newValue) => {
        const { fieldData } = this.state;
        const dataToSearch = {};
        const dataToReset = { ...this.state.fieldData };
        let listError = false;
        holidayStructureJson.fieldMeta.map((currentField) => {
            if (currentField.getDate && currentField.dataKey === fieldName) {
                dataToReset[currentField.getDate] = newValue.add(365, "day");
            }
            if (currentField.dataKey === fieldName && currentField.getListId) {
                const masterKeyList = currentField.getListId.split(",");
                masterKeyList.map((key) => {
                    if (fieldName === key) {
                        dataToSearch[key] = newValue;
                    } else if (fieldData[key]) {
                        dataToSearch[key] = fieldData[key];
                    }
                    return null;
                });
            }
            if (currentField.getListFrom) {
                const masterKeyList = currentField.getListFrom.split(",");
                masterKeyList.map((key) => {
                    if (key == fieldName && dataToReset[key]) {
                        delete dataToReset[currentField.dataKey];
                    }
                });
            }
            if (
                !listError &&
                fieldData[currentField.dataKey] &&
                currentField.controlType != "datepicker" &&
                currentField.getListFrom == undefined
            ) {
                dataToReset[currentField.dataKey] = fieldData[currentField.dataKey];
            }
            return null;
        });

        dataToReset[fieldName] = newValue;
        this.setState({
            fieldData: dataToReset,
        });
    };

    render() {
        const { holidayType, fieldData, formErrors, dynamicMasterData } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        p: 2,
                        borderRadius: 0,
                    }}
                    elevation={0}
                >

                    <DynamicFormWithoutValidation
                        dynamicMasterData={dynamicMasterData}
                        showTitle={holidayStructureJson.showTitle}
                        screenTitle={holidayStructureJson.screenTitle}
                        fieldMeta={holidayStructureJson.fieldMeta}
                        apiBaseURL={holidayStructureJson.apiBaseURL}
                        formErrors={formErrors}
                        showSaveBtn={holidayStructureJson.showSaveBtn}
                        showSaveBtnMain={false}
                        fieldData={fieldData}
                        onDataChange={this.onDataChange}
                        showBackToList={true}
                    />

                    <HolidayStructureDetailsTable
                        dataList={this.props.holidayList?.holiday}
                        holidayType={holidayType}
                        onChangeRadioGroup={this.onChangeRadioGroup}
                        clickSubmitHandler={this.submithandler}
                    />
                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    holidayList: state.year,
});
const mapDispatchToProps = {
    showLoador,
    showNotification,
    getHoliday,
    setHoliday,
    getHolidayYear,
};

export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(HolidayStructureForm);
